import React, { useEffect, useState} from 'react';

import SpinnerDiv from "ui/SpinnerDiv";

import ReadOnlyInput from "ui/ReadOnlyInput";
import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";
import {getChildDetailsWithPromiseForReview} from "root/DataFunctions/ChildDataFns";
import {getProgressReviewDetailsWithPromise} from "root/DataFunctions/ProgressReviewFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";

const ChildProgressReviewHeaderForm = ({child_id, review_id}) =>
{
	const [ data, setData ] = useState ({ loading: true, progress_review: [], child: []})

	useEffect(() => {
		getDataUsingChildId()
	}, []);

	const getDataUsingChildId = () =>
	{
		getChildDetailsWithPromiseForReview(child_id, ['include-school', 'include-esw', 'include-teacher']).then((response) =>
		{
			const childrec = getDataFromResponse(response)[0];

			getProgressReviewDetailsWithPromise(review_id).then((response) =>
			{
				const pr = getDataFromResponse(response);

				setData({loading: false, progress_review: pr, child: childrec});

			})
		});
	}

	const rowChildName = () =>
	{
		return (
			<BootstrapRow>
				<BootstrapCol width={6}>
					<ReadOnlyInput name='inputFirstName' value={data.child.firstname} label='First Name'/>
				</BootstrapCol>
				<BootstrapCol width={6}>
					<ReadOnlyInput name='inputSurname' value={data.child.surname} label='Last Name'/>
				</BootstrapCol>
			</BootstrapRow>
		)
	}

	const rowChildPeople = () =>
	{
		return (
			<BootstrapRow>
				<BootstrapCol width={12}>
					<ReadOnlyInput name='inputFirstName' value={data.child.esw.firstname + ' ' + data.child.esw.surname} label='Link Worker Name'/>
				</BootstrapCol>
			</BootstrapRow>
		)
	}

	const rowSchool = () =>
	{
		return (
			<BootstrapRow>
				<BootstrapCol width={6}>
					<ReadOnlyInput name='inputSchoolName' value={data.child.school.school_name} label='School Name'/>
				</BootstrapCol>
				<BootstrapCol width={6}>
					<ReadOnlyInput name='inputTeacher' value={data.child.teacher.firstname + ' ' + data.child.teacher.surname} label='Teacher Name'/>
				</BootstrapCol>
			</BootstrapRow>
		)
	}

	const getYearDescForTerm = ( row ) =>
	{
		let desc = '' ;

		if ( row.description == null )
		{
			desc = "No Term" ;
		}
		else if ( row.description.length < 6 )
		{
			let yr = +row.year_start + 1 ;
			desc = row.description + ' ' + yr;
		}
		else if ( row.description.substr(0,6) == 'Autumn' )
		{
			desc = row.description + ' ' + row.year_start;
		}
		else
		{
			let yr = +row.year_start + 1 ;
			desc = row.description + ' ' + yr;
		}

		return desc ;
	}

    const rowTerm = () =>
    {
		let stageName = "n/a" ;

		if ( data.progress_review.data.achievement.key_stage_description != null )
		{
			stageName = data.progress_review.data.achievement.key_stage_description ;
		}

		let stage  = stageName + ' / ' + data.child.year_name ;

		return (
			<BootstrapRow>
				<BootstrapCol width={6}>
					<ReadOnlyInput name='inputTerm' value={getYearDescForTerm(data.progress_review)} label='Term'/>
				</BootstrapCol>
				<BootstrapCol width={6}>
					<ReadOnlyInput name='inputStage' value={stage} label='Key Stage'/>
				</BootstrapCol>
			</BootstrapRow>
		)
    }

	const formRow = () =>
    {
		return (
			<div className='panel-body'>
				{ rowChildName() }
				{ rowSchool() }
				{ rowChildPeople() }
				{ rowTerm() }
			</div>
		)
    }

	return data.loading === true ? <SpinnerDiv/> : <div className='panel panel-default'>{formRow()}</div>
}

export default ChildProgressReviewHeaderForm ;
